import React from 'react';

const ThingsToDo: React.FC = () => {
  const categories = [
    {
      title: 'Explore the Temples of Khajuraho',
      icon: '🕌',
      items: [
        { 
          name: 'Western Group of Temples', 
          description: 'The most famous temples including Kandariya Mahadev, Lakshmana, Vishvanatha, and Devi Jagadambi. Intricate carvings depicting mythology, daily life, and artful erotica.' 
        },
        { 
          name: 'Eastern & Southern Groups', 
          description: 'Quieter temples including beautiful Jain temples (Parsvanath, Adinatha, Shantinatha) and Duladeo and Chaturbhuj temples. Perfect for peaceful exploration.' 
        },
        { 
          name: 'Sound & Light Show', 
          description: 'Evening narrated history show in the Western Group complex under the stars with stunning illuminated backdrop.' 
        }
      ]
    },
    {
      title: 'Nature & Scenic Escapes',
      icon: '🌿',
      items: [
        {
          name: 'Panna National Park Tiger Safari (25 km) 🐅',
          description: 'An unforgettable wildlife experience! Take a thrilling jeep safari through Panna National Park to spot Bengal tigers, leopards, crocodiles, and diverse bird species in this pristine wildlife reserve. Early morning safaris offer the best chances for tiger sightings. Book through Kanha Tours for a seamless experience.'
        },
        {
          name: 'Raneh Falls & Ken River Gorge (20 km)',
          description: 'Dramatic canyon of multicolored granite with seasonal waterfalls. Perfect for morning excursions and golden-hour photography.'
        },
        {
          name: 'Pandav Falls & Caves (35 km)',
          description: 'Serene forest waterfall tied to Mahabharata legends. Ideal for nature lovers and quiet picnics.'
        }
      ]
    },
    {
      title: 'Historical Day Trips',
      icon: '🏰',
      items: [
        { 
          name: 'Orchha (4 hrs away)', 
          description: 'Hidden architectural gem with stunning palaces, cenotaphs, and temples along the Betwa River.' 
        },
        { 
          name: 'Kalinjar Fort (2 hrs)', 
          description: 'Historic hilltop fort with panoramic views and deep military history.' 
        },
        { 
          name: 'Ajaygarh Fort (40 km)', 
          description: 'Less touristy fort with dramatic setting. Great hiking adventure for the adventurous.' 
        }
      ]
    }
  ];

  return (
    <div className="space-y-24">
      <div className="text-center">
        <h1 className="text-4xl font-display font-medium text-sage-800 mb-4">
          Things to Do
        </h1>
        <div className="elegant-divider"></div>
        <p className="text-sage-grey-600 max-w-3xl mx-auto leading-relaxed">
          For guests arriving early or extending their stay, Khajuraho and surrounding areas offer incredible temples, nature, culture, and history to explore.
        </p>
      </div>

      {/* Kanha Tours Partnership */}
      <div className="glass-card p-8 sm:p-12 bg-sage-50 border-2 border-sage-200">
        <div className="text-center mb-6">
          <h2 className="text-2xl font-display font-medium text-soft-black mb-4">
            Book Your Adventures with Kanha Tours
          </h2>
          <div className="elegant-divider"></div>
        </div>
        <p className="text-text-gray leading-relaxed mb-6 text-center max-w-2xl mx-auto">
          We've partnered with <strong className="text-soft-black">Kanha Tours</strong>, a trusted local travel agency, to help you book tours and experiences during your stay in Khajuraho.
        </p>
        <div className="bg-pure-white p-6 sm:p-8 border border-mid-gray">
          <h3 className="text-sm font-medium text-soft-black mb-4 uppercase tracking-wider text-center">
            How to Book
          </h3>
          <div className="space-y-4 text-center">
            <p className="text-text-gray leading-relaxed">
              Contact Kanha Tours directly and mention your dates along with <strong className="text-soft-black">"Shivangi and Ishan's Wedding"</strong> to make your bookings.
            </p>
            <div className="pt-4">
              <a
                href="tel:+919993929951"
                className="inline-flex items-center justify-center minimal-button px-8 py-3"
              >
                <span className="mr-2">📞</span>
                +91 99939 29951
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-16">
        {categories.map((category, index) => (
          <div key={index} className="glass-card p-12">
            <div className="mb-8">
              <div className="flex items-center mb-4">
                <span className="text-3xl mr-4">{category.icon}</span>
                <h2 className="font-display text-soft-black tracking-wide">
                  {category.title}
                </h2>
              </div>
              <div className="elegant-divider"></div>
            </div>
            
            <div className="grid md:grid-cols-1 gap-8">
              {category.items.map((item, itemIndex) => (
                <div key={itemIndex} className="timeline-minimal">
                  <h3 className="font-display text-soft-black text-lg mb-3 tracking-wide">
                    {item.name}
                  </h3>
                  <p className="text-text-gray leading-relaxed">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default ThingsToDo;